import { Helper } from '../Helper';
export class RawEnumeratorForEachHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEachBase({
            each: (innerOptions) => {
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                this.each(sb.noPushValueOptions(innerOptions));
            },
        }));
    }
}

//# sourceMappingURL=RawEnumeratorForEachHelper.js.map
